<template>
    <v-expansion-panel>
        <block v-if="loading"></block>
        <v-expansion-panel-header class="mt-2">
            Calendario
            <template v-slot:actions>
                <v-btn class="mr-5" @click.native.stop="reloadView++" icon small>
                    <v-icon color="primary">mdi-reload</v-icon>
                </v-btn>
                <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
                    <v-icon color="error">mdi-close</v-icon>
                </v-btn>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content :key="reloadView">
            <div class="pa-1">
                <v-row class="white ma-0 rounded-lg">
                    <v-col class="spacerow ma-4">
                        <div style="display: flex; flex-wrap: wrap; justify-content: space-around;">
                            <div>
                                <input type="radio" id="awaiting" value="0" v-model="typeCalendar" />
                                <label class="spacing" for="awaiting"><b> Calendario general</b></label>
                            </div>
                            <div>
                                <input type="radio" id="Attending" value="1" v-model="typeCalendar" />
                                <label class="spacing" for="Attending"><b> Calendario de Peluqueria</b></label>
                            </div>
                            <!-- comentado hasta implementar la funcionalidad de calendario de citas médicas -->
                            <!-- <div>
                                <input type="radio" id="Attending2" value="2" v-model="typeCalendar" />
                                <label class="spacing" for="Attending2"><b> Calendario de Citas médicas</b></label>
                            </div> -->
                            <div>
                                <input type="radio" id="cats" value="3" v-model="typeCalendar" />
                                <label class="spacing" for="cats"><b> Calendario de Citas</b></label>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="typeCalendar == 0" class="ma-0 mt-3">
                    <v-col class="pa-0">
                        <v-sheet style="height: 120px !important;">
                            <v-toolbar flat style="height: 100px !important" >
                                <v-row align="center" no-gutters class="d-flex bg-white flex-column flex-sm-row spacerow">
                                    <v-col cols="12" md="5" sm="5" xs="5" class="d-flex flex-column flex-md-row align-center justify-center justify-md-space-between mb-4 mb-sm-0">
                                        <div class="d-flex align-center justify-center">
                                             <v-btn outlined class="mr-2" color="grey darken-2" @click="setToday">Hoy</v-btn>
                                             <v-btn text small color="grey darken-2" @click="prev">
                                              <v-icon small>mdi-chevron-left</v-icon>
                                             </v-btn>
                                             <v-btn text small color="grey darken-2" @click="next">
                                                 <v-icon small>mdi-chevron-right</v-icon>
                                             </v-btn>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="2" sm="2" xs="2" class="d-flex align-center justify-center mb-4 mb-sm-0" style="align-content: center;">
                                        <v-toolbar-title v-if="$refs.calendar">
                                            {{ $refs.calendar.title }}
                                        </v-toolbar-title>
                                    </v-col>
                                    <v-col cols="12" md="5" sm="5" xs="5" class="d-flex justify-center justify-md-end">
                                        <v-menu bottom right>
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                                <span>{{ typeToLabel[type] }}</span>
                                                <v-icon right>mdi-menu-down</v-icon>
                                            </v-btn>
                                            </template>
                                            <v-list>
                                            <v-list-item @click="type = 'day'">
                                                <v-list-item-title>Ver por día</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'week'">
                                                <v-list-item-title>Ver por semana</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'month'">
                                                <v-list-item-title>Ver por mes</v-list-item-title>
                                            </v-list-item>
                                            </v-list>
                                        </v-menu>
                                        <v-btn text color="primary" dark style="margin-left: 10px;" @click="openModalByButton">
                                            Agregar cita
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                </v-toolbar>
                        </v-sheet>
                        <v-sheet height="600">
                            <v-calendar style="padding-bottom: 20px;" :locale="locale" ref="calendar" v-model="focus" color="primary" :events="events"
                                :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay"
                                @click:date="viewDay" @change="updateRange"></v-calendar>
                            <v-menu v-model="selectedOpen" max-width="400px" :close-on-content-click="false" :activator="selectedElement"
                                offset-x>
                                <v-card color="grey lighten-4" min-width="30px" flat>
                                    <v-toolbar :color="selectedEvent.color" dark>
                                        <v-btn icon @click="delSelectedOpen"
                                            color="error"
                                            v-if="selectedEvent.name != 'Cita de vacunación' && selectedEvent.name != 'Cita de medicación' && selectedEvent.name != 'Cita médica' && selectedEvent.name != 'Cita de peluquería'">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="editEvent"
                                            color="primary"
                                            v-if="selectedEvent.name == 'Cita de peluquería'">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text class="m-1" style="background: white;">
                                        <div class="d-flex flex-column">
                                            <div class="d-flex">
                                                <div class="mr-1">
                                                    <b>Cliente: </b>
                                                </div>
                                                <div :style="{color: selectedEvent.customer ? 'inherit' : '#9E9E9E'}">
                                                    {{ selectedEvent.customer 
                                                        ? selectedEvent.customer
                                                        : 'No asignado' }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.specialStatus === 'grooming'">
                                                <div class="mr-1">
                                                    <b>Paciente: </b>
                                                </div>
                                                <div :style="{color: selectedEvent.patient ? 'inherit' : '#9E9E9E'}">
                                                     {{ selectedEvent.patient 
                                                        ? selectedEvent.patient
                                                        : 'No asignado' }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.specialStatus">
                                                <div class="mr-1">
                                                    <b>Tipo de sevicio: </b>
                                                </div>
                                                <div :style="{color: selectedEvent.serviceType ? 'inherit' : '#9E9E9E'}">
                                                     {{ selectedEvent.serviceType 
                                                        ? selectedEvent.serviceType
                                                        : 'No especificado' }}    
                                                </div>
                                            </div>
                                            <div class="d-flex">
                                                <div class="mr-1">
                                                    <b>Detalles: </b>
                                                </div>
                                                <div :style="{color: selectedEvent.details ? 'inherit' : '#9E9E9E'}" v-html="selectedEvent.details 
                                                        ? selectedEvent.details
                                                        : 'Sin especificar'">
                                                </div>
                                            </div>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn text color="secondary" @click="selectedOpen = false">
                                            Cerrar
                                        </v-btn>
                                        <v-btn text v-if="selectedEvent.SpecialStatus == 'grooming'" color="primary" @click="editEvent">
                                            Editar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-sheet>
                    </v-col>
                </v-row>

                <v-row v-if="typeCalendar == 1" class="ma-0 mt-3">
                    <v-col class="pa-0">
                        <v-sheet height="600" rounded="lg">
                            <calendar
                                class="rounded-lg"
                                v-model="focus"
                                @click:event="showEvent"
                                @click:time="openModalByTime"
                                @change="updateRange"
                                :events="events2"
                                height="500px"
                                type="week"
                                hide-controls
                                hide-action>
                            </calendar>
                            <v-menu v-model="selectedOpen" max-width="400px" :close-on-content-click="false" :activator="selectedElement"
                                offset-x>
                                <v-card color="grey lighten-4" min-width="30px" flat>
                                    <v-toolbar :color="selectedEvent.color" dark>
                                        <v-btn icon @click="delSelectedOpen"
                                            color="error"
                                            v-if="selectedEvent.name != 'Cita de vacunación' && selectedEvent.name != 'Cita de medicación' && selectedEvent.name != 'Cita médica' && selectedEvent.name != 'Cita de peluquería'">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="editEvent"
                                            color="primary"
                                            v-if="selectedEvent.name == 'Cita de peluquería'">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text class="m-1" style="background: white;">
                                        <div class="d-flex flex-column">
                                            <div class="d-flex" v-if="selectedEvent.customer">
                                                <div class="mr-1">
                                                    <b>Cliente: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.customer }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.patient">
                                                <div class="mr-1">
                                                    <b>Paciente: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.patient }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.GroomingTypeOfService">
                                                <div class="mr-1">
                                                    <b>Tipo de servicio: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.GroomingTypeOfService }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.GroomingSize">
                                                <div class="mr-1">
                                                    <b>Tamaño: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.GroomingSize }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.GroomingGroomer">
                                                <div class="mr-1">
                                                    <b>Peluquero: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.GroomingGroomer }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.GroomingVisit">
                                                <div class="mr-1">
                                                    <b>Visita: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.GroomingVisit }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.Domicilio">
                                                <div class="mr-1">
                                                    <b>Ubicación: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.Domicilio ? 'Domicilio' : 'Local' }}    
                                                </div>
                                            </div>
                                            <div class="d-flex" v-if="selectedEvent.appointmentDetails">
                                                <div class="mr-1">
                                                    <b>Detalles: </b>
                                                </div>
                                                <div>
                                                    {{ selectedEvent.appointmentDetails }}  
                                                </div>
                                            </div>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn text color="secondary" @click="selectedOpen = false">
                                            Cerrar
                                        </v-btn>
                                        <v-btn text color="primary" @click="editEvent">
                                            Editar
                                        </v-btn>
                                        <v-btn text v-if="selectedEvent.SpecialStatus == 'grooming'" color="primary" @click="showLastPhoto">
                                            Galería
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-sheet>
                    </v-col>
                </v-row>

                <v-row v-if="typeCalendar == 2"
                    style="background: white; width: 98%; margin: 0 auto; margin-left: 1%; margin-right: 1%; margin-top: 30px; margin-bottom: 30px;" >
                    <v-col class="spacerow">
                        <v-sheet height="600">
                            <calendar
                                v-model="currentDate"
                                @click:event="showEvent"
                                @click:time="openModalByTime"
                                :events="events2"
                                height="500px"
                                type="week"
                                hide-controls
                                hide-action>
                            </calendar>
                            <v-menu v-model="selectedOpen" max-width="400px" :close-on-content-click="false" :activator="selectedElement"
                                offset-x>
                                <v-card color="grey lighten-4" min-width="30px" flat>
                                    <v-toolbar :color="selectedEvent.color" dark>
                                        <v-btn icon @click="delSelectedOpen"
                                            v-if="selectedEvent.name != 'Cita de vacunación' && selectedEvent.name != 'Cita de medicación' && selectedEvent.name != 'Cita médica' && selectedEvent.name != 'Cita de peluquería'">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="editEvent"
                                            color="primary"
                                            v-if="selectedEvent.name == 'Cita de peluquería'">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text class="m-1" style="background: white;">
                                        <span  v-html="selectedEvent.details"></span>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn text color="secondary" @click="selectedOpen = false">
                                            Cerrar
                                        </v-btn>
                                        <v-btn text color="primary" @click="editEvent">
                                            Editar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-sheet>
                    </v-col>
                </v-row>

                <v-row v-if="typeCalendar == 3" class="ma-0 mt-3">
                    <v-col class="pa-0">
                        <v-sheet height="600" rounded="lg">
                            <calendar
                                class="rounded-lg"
                                v-model="focus"
                                @click:event="showEvent"
                                @click:time="openModalByTime"
                                @change="updateRange"
                                :events="eventsCats"
                                height="500px"
                                type="week"
                                hide-controls
                                hide-action>
                            </calendar>
                            <v-menu v-model="selectedOpen" max-width="400px" :close-on-content-click="false" :activator="selectedElement"
                                offset-x>
                                <v-card color="grey lighten-4" min-width="30px" flat>
                                    <v-toolbar :color="selectedEvent.color" dark>
                                        <v-btn icon @click="delSelectedOpen"
                                            color="error"
                                            v-if="selectedEvent.name != 'Cita de vacunación' && selectedEvent.name != 'Cita de medicación' && selectedEvent.name != 'Cita médica' && selectedEvent.name != 'Cita de peluquería'">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="editEvent"
                                            color="primary"
                                            v-if="selectedEvent.name == 'Cita de peluquería'">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text class="m-1" style="background: white;">
                                        <span  v-html="selectedEvent.details"></span>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn text color="secondary" @click="selectedOpen = false">
                                            Cerrar
                                        </v-btn>
                                        <v-btn text color="primary" @click="editEvent">
                                            Editar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-sheet>
                    </v-col>
                </v-row>

                <v-dialog v-model="showForm" width="60%" scrollable>
                    <v-card>
                        <v-row>
                            <v-col>
                                <v-card-title class="mx-1 my-1">
                                    Agregar cita de veterinaria
                                </v-card-title>
                            </v-col>
                            <v-col cols="3" md="3" class="d-flex justify-end mx-5 my-5">
                                <v-btn color="error" dark @click="() => {
                                    editingGeneralAppointment = false;
                                    handleSelection(null)
                                    showForm = false;
                                }">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-card-text>
                            <template v-if="editingGeneralAppointment">
                                <v-row class="my-2" v-if="appointmentForm.id == null">
                                    <v-col cols="6">
                                        <v-btn 
                                            color="comment" 
                                            dark 
                                            @click="() => {
                                                selectedPatient = null
                                                editingGeneralAppointment = false
                                            }" 
                                        >
                                            <v-icon>mdi-arrow-left</v-icon> Regresar
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-row class="pt-5">
                                    <v-col cols="6">
                                        <v-text-field 
                                            v-if="!appointmentForm.id" 
                                            outlined 
                                            dense 
                                            v-model="appointmentForm.AppointmentStartDate"
                                            label="Fecha cita:" 
                                            disabled
                                        ></v-text-field>
                                        <date-picker v-else outlined dense label="Fecha de inicio"
                                            @dateSelected="(param) => appointmentForm.AppointmentStartDate = param"
                                            :value="appointmentForm.AppointmentStartDate"></date-picker>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-flex v-if="appointmentForm.id !== null">
                                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                                :return-value.sync="appointmentForm.AppointmentStartHour" lazy transition="scale-transition" offset-y full-width
                                                max-width="290px" min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field outlined dense v-model="appointmentForm.AppointmentStartHour" label="Hora inicio"
                                                    readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-time-picker outlined dense v-if="menu2" v-model="appointmentForm.AppointmentStartHour" full-width
                                                    @click:minute="$refs.menu2.save(appointmentForm.AppointmentStartHour)"></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-text-field v-else outlined dense v-model="appointmentForm.AppointmentStartHour"
                                            label="Hora inicio" disabled></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="6">
                                        <v-flex v-if="appointmentForm.id !== null">
                                            <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                                                :return-value.sync="appointmentForm.AppointmentEndHour" lazy transition="scale-transition" offset-y full-width
                                                max-width="290px" min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field outlined dense v-model="appointmentForm.AppointmentEndHour" label="Hora de fin"
                                                    readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-time-picker outlined dense v-if="menu3" v-model="appointmentForm.AppointmentEndHour" full-width
                                                    @click:minute="$refs.menu3.save(appointmentForm.AppointmentEndHour)"></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-text-field v-else outlined dense v-model="appointmentForm.AppointmentEndHour"
                                        label="Hora Fin" disabled></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field class="d-none" outlined dense v-model="appointmentForm.AppointmentName"
                                            label="Titulo de cita" disabled></v-text-field>
                                    </v-col>
                                </v-row>
                                <!-- Campos condicionales para grooming/cats -->
                                <template v-if="appointmentForm.SpecialStatus !== 'cats'">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-select outlined dense :items="services" v-model="appointmentForm.GroomingTypeOfService"
                                            label="Tipo de servicio" item-text="label" item-value="value" attach>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-select outlined dense attach :items="sizes" v-model="appointmentForm.GroomingSize"
                                            label="Selecciona tamaño" item-text="label" item-value="value">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field outlined dense v-model="appointmentForm.GroomingGroomer"
                                                label="Peluquero"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field outlined dense v-model="appointmentForm.GroomingVisit"
                                                label="Visita"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </template>
                                <!-- Mostrar solo Tipo de servicio para cats -->
                                <template v-if="appointmentForm.SpecialStatus === 'cats'">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-autocomplete 
                                                outlined 
                                                dense 
                                                :items="searchedServices" 
                                                v-model="appointmentForm.GroomingTypeOfService"
                                                label="Tipo de servicio" 
                                                item-text="label" 
                                                item-value="value" 
                                                attach
                                                clearable
                                                :search-input.sync="searchService"
                                                :loading="searchingServices"
                                                no-data-text="No se encontraron servicios"
                                                placeholder="Buscar tipo de servicio..."
                                                :allow-overflow="false"
                                                :menu-props="{ offsetY: true }"
                                                hint="Escriba para buscar servicios disponibles"
                                                persistent-hint
                                                @update:search-input="onSearchServices">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </template>
                                <v-row>
                                    <v-col cols="6">
                                        <v-checkbox v-model="appointmentForm.Domicilio" label="Domicilio" :true-value="1" :false-value="0" />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-textarea outlined dense v-model="appointmentForm.AppointmentDetails"
                                            label="Detalle de la cita"></v-textarea>
                                    </v-col>
                                </v-row>
                            </template>

                            <template v-else>
                                <v-row v-if="showTablePatients" v-show="selectedPatient == null">
                                    <v-col class="mt-5">
                                        <Button 
                                            class="d-flex align-center" 
                                            @click="() => {
                                                editingGeneralAppointment = true;
                                                handleSelection(null);
                                            }"
                                        >
                                            <div class="mr-1">Agregar cita general</div>
                                            <v-icon>mdi-plus</v-icon>
                                        </Button>
                                        <GeneralFilter v-model="filterPatients" :filterEndpoint="$API.veterinaryCalendar.getPatientWithCustomer" :search="{filter: filterPatients}"
                                            @emptyFilter="getPatientWithCustomer" @filtered="filterHandlerPatients">
                                            <p
                                                class="py-2" 
                                                style="font-size: 18px;"
                                            >
                                                Seleccione el paciente al que quiere agendar una cita de peluqueria:
                                            </p>
                                            <DxDataGrid :column-auto-width="true" :data-source="patientsWithCustomer" :scrolling="{ useNative: true }">
                                                <DxPaging :page-size="5" />
                                                <DxColumn caption="" :width="50" cell-template="select-patient"></DxColumn>
                                                <DxColumn data-field="ID_Patient" caption="ID Paciente"></DxColumn>
                                                <DxColumn data-field="NamePatient" caption="Paciente"></DxColumn>
                                                <DxColumn data-field="FullName" caption="Cliente"></DxColumn>
                                                <DxColumn data-field="OldID" caption="Código Alterno"></DxColumn>
                                                <template #select-patient="{ data }">
                                                    <div>
                                                        <v-checkbox @change="handleSelection(data.data)"/>
                                                    </div>
                                                </template>
                                            </DxDataGrid>
                                        </GeneralFilter>
                                    </v-col>
                                </v-row>

                                <template v-if="showTablePatients && selectedPatient != null">
                                    <v-row class="mb-2" v-if="appointmentForm.id == null">
                                        <v-col cols="6">
                                            <v-btn color="comment" dark @click="selectedPatient = null" ><v-icon>mdi-arrow-left</v-icon> Regresar</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field outlined dense v-model="appointmentForm.ID_Patient"
                                                label="ID Paciente" disabled></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field outlined dense v-model="appointmentForm.ID_Customer"
                                                label="ID Cliente" disabled></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field outlined dense v-model="selectedPatient.NamePatient"
                                                label="Paciente" disabled></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field outlined dense v-model="selectedPatient.FullName"
                                                label="Cliente" disabled></v-text-field>
                                        </v-col>
                                    </v-row>
    
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field outlined dense v-model="appointmentForm.AppointmentStartDate"
                                                label="Fecha cita:" disabled></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-flex v-if="appointmentForm.id !== null">
                                                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                                    :return-value.sync="appointmentForm.AppointmentStartHour" lazy transition="scale-transition" offset-y full-width
                                                    max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field outlined dense v-model="appointmentForm.AppointmentStartHour" label="Hora inicio"
                                                        readonly v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker outlined dense v-if="menu2" v-model="appointmentForm.AppointmentStartHour" full-width
                                                        @click:minute="$refs.menu2.save(appointmentForm.AppointmentStartHour)"></v-time-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-text-field v-else outlined dense v-model="appointmentForm.AppointmentStartHour"
                                                label="Hora inicio" disabled></v-text-field>
                                        </v-col>
                                    </v-row>
    
                                    <v-row>
                                        <v-col cols="6">
                                            <v-flex v-if="appointmentForm.id !== null">
                                                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                                                    :return-value.sync="appointmentForm.AppointmentEndHour" lazy transition="scale-transition" offset-y full-width
                                                    max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field outlined dense v-model="appointmentForm.AppointmentEndHour" label="Hora de fin"
                                                        readonly v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker outlined dense v-if="menu3" v-model="appointmentForm.AppointmentEndHour" full-width
                                                        @click:minute="$refs.menu3.save(appointmentForm.AppointmentEndHour)"></v-time-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-text-field v-else outlined dense v-model="appointmentForm.AppointmentEndHour"
                                            label="Hora Fin" disabled></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field class="d-none" outlined dense v-model="appointmentForm.AppointmentName"
                                                label="Titulo de cita" disabled></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <!-- Campos condicionales para grooming/cats -->
                                    <template v-if="appointmentForm.SpecialStatus !== 'cats'">
                                        <v-row>
                                            <v-col cols="6">
                                                <v-select outlined dense :items="services" v-model="appointmentForm.GroomingTypeOfService"
                                                label="Tipo de servicio" item-text="label" item-value="value" attach>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-select outlined dense attach :items="sizes" v-model="appointmentForm.GroomingSize"
                                                label="Selecciona tamaño" item-text="label" item-value="value">
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field outlined dense v-model="appointmentForm.GroomingGroomer"
                                                    label="Peluquero"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field outlined dense v-model="appointmentForm.GroomingVisit"
                                                    label="Visita"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <!-- Mostrar solo Tipo de servicio para cats -->
                                    <template v-if="appointmentForm.SpecialStatus === 'cats'">
                                        <v-row>
                                            <v-col cols="6">
                                                <v-autocomplete 
                                                    outlined 
                                                    dense 
                                                    :items="searchedServices" 
                                                    v-model="appointmentForm.GroomingTypeOfService"
                                                    label="Tipo de servicio" 
                                                    item-text="label" 
                                                    item-value="value" 
                                                    attach
                                                    clearable
                                                    :search-input.sync="searchService"
                                                    :loading="searchingServices"
                                                    no-data-text="No se encontraron servicios"
                                                    placeholder="Buscar tipo de servicio..."
                                                    :allow-overflow="false"
                                                    :menu-props="{ offsetY: true }"
                                                    hint="Escriba para buscar servicios disponibles"
                                                    persistent-hint
                                                    @update:search-input="onSearchServices">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-checkbox v-model="appointmentForm.Domicilio" label="Domicilio" :true-value="1" :false-value="0" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-textarea outlined dense v-model="appointmentForm.AppointmentDetails"
                                                label="Detalle de la cita"></v-textarea>
                                        </v-col>
                                    </v-row>
                                </template>

                                <template v-if="!showTablePatients">
                                    <v-row class="mt-5">
                                        <v-col>
                                            <v-text-field outlined dense v-model="appointmentForm.AppointmentName"
                                                label="Titulo de cita"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-textarea outlined dense v-model="appointmentForm.AppointmentDetails"
                                                label="Detalle de la cita"></v-textarea>
                                        </v-col>
                                    </v-row>
    
                                    <v-row>
                                        <v-col>
                                            <date-picker outlined dense label="Fecha de inicio"
                                                @dateSelected="(param) => (appointmentForm.AppointmentStartDate = param)"
                                                :value="appointmentForm.AppointmentStartDate"></date-picker>
                                        </v-col>
    
                                        <v-col>
                                            <v-flex>
                                                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                                    :return-value.sync="appointmentForm.AppointmentStartHour" lazy transition="scale-transition" offset-y full-width
                                                    max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field outlined dense v-model="appointmentForm.AppointmentStartHour" label="Hora de inicio"
                                                        readonly v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker outlined dense v-if="menu2" v-model="appointmentForm.AppointmentStartHour" full-width
                                                        @click:minute="$refs.menu2.save(appointmentForm.AppointmentStartHour)"></v-time-picker>
                                                </v-menu>
                                            </v-flex>
                                        </v-col>
                                    </v-row>
    
                                    <v-row>
                                        <v-col>
                                            <date-picker outlined dense label="Fecha fin"
                                                @dateSelected="(param) => (appointmentForm.AppointmentEndDate = param)"
                                                :value="appointmentForm.AppointmentEndDate"></date-picker>
                                        </v-col>
    
                                        <v-col>
                                            <v-flex>
                                                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                                                    :return-value.sync="appointmentForm.AppointmentEndHour" lazy transition="scale-transition" offset-y full-width
                                                    max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field outlined dense v-model="appointmentForm.AppointmentEndHour" label="Hora de fin"
                                                        readonly v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker outlined dense v-if="menu3" v-model="appointmentForm.AppointmentEndHour" full-width
                                                        @click:minute="$refs.menu3.save(appointmentForm.AppointmentEndHour)"></v-time-picker>
                                                </v-menu>
                                            </v-flex>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-autocomplete attach outlined dense v-model="appointmentForm.ID_Customer" :items="customers" item-text="NameCustomer" item-value="ID_Customer" label="Seleccione el cliente" v-on:change="getPatient" ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-autocomplete attach outlined dense v-model="appointmentForm.ID_Patient" :items="patients" item-text="NamePatient" item-value="ID_Patient" label="Seleccione el paciente" ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </template>
                            </template>
                        </v-card-text>
                        <v-card-actions class="d-flex flex-row-reverse ">
                            <template v-if="editingGeneralAppointment">
                                <v-btn 
                                    v-if="appointmentForm.id !== null" 
                                    color="save" 
                                    title="Actualizar cita general" 
                                    dark 
                                    @click="updateAppointment"
                                >
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                                <v-btn v-else color="save" title="Agregar cita general" dark @click="addAppointmentDate">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                            </template>
                            <template v-else>
                                <template v-if="showTablePatients && selectedPatient != null">
                                    <v-btn 
                                        v-if="appointmentForm.id !== null" 
                                        color="save" 
                                        title="Actualizar cita de paciente" 
                                        dark 
                                        @click="updateAppointment"
                                    >
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>
                                    <v-btn v-else color="save" title="Agregar cita de paciente" dark @click="addAppointmentDate">
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>
                                </template>
                                <template v-if="!showTablePatients">
                                    <v-btn color="save" title="Guardar cita" dark @click="addAppointmentDate">
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>
                                </template>
                            </template>


                            
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
                </alerts>
            </div>
        </v-expansion-panel-content>
        <v-dialog v-model="ZoomDialog" scrollable max-width="90%">
            <v-card>
                <v-card-title>
                <span>Previsualización</span>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="ZoomDialog = false" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-card-title>
                <v-card-text>
                <ZoomImage :imageUrl="imageUrl" :type="''"></ZoomImage>
                <div v-if="!imageUrl" class="notImgs">Aun no se han agregado imagenes</div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-expansion-panel>
</template>
<script>

import DatePicker from '../../components/DatePicker.vue';
import Alerts from '../../components/Alerts';
import { DxDataGrid, DxColumn, DxPaging } from "devextreme-vue/data-grid";
import GeneralFilter from "@/components/GeneralFilter";
import Button from "@/components/Button.vue";
import ZoomImage from '../../components/VeterinaryImage/zoomImageView.vue';
import Block from "@/components/Block"
//import Vue from 'vue';

export default {
    name: "VeterinaryCalendar",
    components: { DatePicker, DxPaging, DxColumn, Alerts, DxDataGrid, GeneralFilter, Button, Block, ZoomImage },
    props: ["win"],
    data() {
        return {
            loading: false,
            currentDate: '',
            reloadView: 0,
            locale: 'es',
            focus: '',
            type: 'month',
            typeToLabel: {
                month: 'Vista por mes',
                week: 'Vista por semana',
                day: 'Vista por día',
                '4day': '4 Days',
            },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            events2: [],
            eventsCats: [],
            colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
            names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
            showForm: false,
            appointmentForm: {
                AppointmentName: '',
                AppointmentDetails: '',
                AppointmentStartDate: new Date(),
                AppointmentEndDate: new Date(),
                AppointmentStartHour: '07:00',
                AppointmentEndHour: '07:30',
                ID_Patient: null,
                ID_Customer: null,
                id: null,
                Domicilio: 0,
            },
            menu2: false,
            menu3: false,
            modal2: false,
            modal3: false,
            customers: [],
            patients: [],
            alert: {
                type: null,
                show: false,
                header: "",
                body: "",
            },
            policlinicaclientdata: JSON.parse(localStorage.getItem("user")).policlinicaclientdata,
            typeCalendar: 0,
            showTablePatients: false,
            patientsWithCustomer: [],
            filterPatients: '',
            selectedPatient: null,
            sizes: [
                { label: 'Grande', value: "Grande" },
                { label: 'Mediano', value: "Mediano" },
                { label: 'Pequeño', value: "Pequeño" },
            ],
            lastDateRange: null,
            servicesOpcFromApi: [],
            searchService: null,
            searchedServices: [],
            searchingServices: false,
            searchTimeout: null,
            editingGeneralAppointment: false,
            imagesToShow: [],
            ZoomDialog: false,
            imageUrl: null,
        }
    },
    computed: {
        services() {
            // Para calendario veterinario (typeCalendar == 1) retorna servicios de peluquería
            if (this.typeCalendar == 1) {
                return [
                    { label: 'Baño', value: "Baño" },
                    { label: 'Baño Medicado', value: "Baño Medicado" },
                    { label: 'Corte', value: "Corte" },
                    { label: 'Corte de uñas', value: "Corte de uñas" },
                    { label: 'Corte y Baño', value: "Corte y Baño" },
                    { label: 'Corte y Baño Medicado', value: "Corte y Baño Medicado" },
                    { label: 'Vaciamiento de glándulas adanales', value: "Vaciamiento de glándulas adanales" },
                    { label: 'Recorte de pelo de orejas', value: "Recorte de pelo de orejas" },
                    { label: 'Lavado de dientes', value: "Lavado de dientes" },
                ];
            }
            // Para calendario de gatos (typeCalendar == 3) retorna servicios de la API
            else if (this.typeCalendar == 3) {
                return this.servicesOpcFromApi;
            }
            // Para calendario general (typeCalendar == 0) o cualquier otro
            else {
                return [
                    { label: 'Baño', value: "Baño" },
                    { label: 'Baño Medicado', value: "Baño Medicado" },
                    { label: 'Corte', value: "Corte" },
                    { label: 'Corte de uñas', value: "Corte de uñas" },
                    { label: 'Corte y Baño', value: "Corte y Baño" },
                    { label: 'Corte y Baño Medicado', value: "Corte y Baño Medicado" },
                    { label: 'Vaciamiento de glándulas adanales', value: "Vaciamiento de glándulas adanales" },
                    { label: 'Recorte de pelo de orejas', value: "Recorte de pelo de orejas" },
                    { label: 'Lavado de dientes', value: "Lavado de dientes" },
                ];
            }
        }
    },
    mounted() {
        this.getCustomer()
        this.getPatientWithCustomer()
        this.getServicesOpc()
        this.$refs.calendar.checkChange()
    },
    methods: {
        customIntervalFormat(interval) {
            return `${interval.hour}:${interval.minute < 10 ? '0' : ''}${interval.minute}`;
        },
        showAlert(type, header, body, options = null){
            type = (type == null) ? "danger" : type
            this.alert.type = type
            this.alert.header = header
            this.alert.body = body
            this.alert.show = true
            this.alert.options = (options != null) ? options : null
        },
        closeAlert() {
            this.alert.show = false
            if (this.alert.options == 'add') {
                if (this.lastDateRange) {
                    this.updateRange(this.lastDateRange)
                }
                this.appointmentForm.AppointmentStartHour = '07:00'
                this.appointmentForm.AppointmentEndHour = '07:30'
                this.appointmentForm.AppointmentName = null
                this.appointmentForm.AppointmentDetails = null
                this.appointmentForm.AppointmentStartDate = null
                this.appointmentForm.AppointmentEndDate = null
                this.appointmentForm.ID_Customer = null
                this.appointmentForm.ID_Patient = null
                this.appointmentForm.id = null
            }
        },
        async getCustomer(){
            this.$API.veterinaryCalendar.getCustomer().then((response) => {
                this.customers = response
            }).catch((err) => {
                console.log(err)
            })
        },
        async getPatient(){
            this.$API.veterinaryCalendar.getPatient({ ID_Customer: this.appointmentForm.ID_Customer }).then((response) => {
                this.patients = response
            }).catch((err) => {
                console.log(err)
            })
        },
        async getPatientWithCustomer() {
            this.$API.veterinaryCalendar.getPatientWithCustomer({ filter: this.filterPatients })
            .then(response => {
                this.patientsWithCustomer = response  
            })
        },
        async getServicesOpc() {
            this.$API.services.getAllServicesOpc().then((response) => {
                this.servicesOpcFromApi = response
                // Inicializar con todos los servicios para búsqueda
                this.searchedServices = response
            }).catch((err) => {
                console.log('Error al obtener servicios:', err)
            })
        },
        
        onSearchServices(searchQuery) {
            // Limpiar timeout anterior
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            
            // Si no hay query, mostrar servicios básicos
            if (!searchQuery || searchQuery.trim() === '') {
                this.searchedServices = this.servicesOpcFromApi
                return
            }
            
            // Debounce la búsqueda para evitar muchas llamadas a la API
            this.searchTimeout = setTimeout(() => {
                this.searchServicesInAPI(searchQuery)
            }, 300) // 300ms de delay
        },
        
        async searchServicesInAPI(query) {
            if (!query || query.trim() === '') return
            
            this.searchingServices = true
            
            try {
                const response = await this.$API.services.searchServicesOpc(query.trim())
                this.searchedServices = response.success ? response.data : []
            } catch (err) {
                console.log('Error al buscar servicios:', err)
                // En caso de error, usar filtrado local como fallback
                this.searchedServices = this.servicesOpcFromApi.filter(service => 
                    service.label.toLowerCase().includes(query.toLowerCase()) ||
                    service.value.toLowerCase().includes(query.toLowerCase())
                )
            } finally {
                this.searchingServices = false
            }
        },
        
        viewDay({ date }) {
            this.focus = date
            this.type = 'day'
        },
        getEventColor(event) {
            return event.color
        },
        setToday() {
            this.focus = ''
        },
        prev() {
            this.$refs.calendar.prev()
        },
        next() {
            this.$refs.calendar.next()
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        updateRange(dateRange) {
            this.lastDateRange = dateRange; // Guarda el último rango recibido
            const dateStart = this.moment(
                dateRange.start.date).subtract(1, 'week').format("YYYY-MM-DD");
            const dateEnd = this.moment(
                dateRange.end.date).add(1, 'week').format("YYYY-MM-DD");
            const events = []
            const events2 = []
            this.$API.veterinaryCalendar.getAppointmentsOfVeterinaryForms({dateStart, dateEnd}).then((response) => {
                for (let i = 0; i < response.prescription.length; i++) {
                    events.push({
                        name: "Cita médica",
                        details: "<b>Cliente: </b> " + response.prescription[i].NameCustomer + "<br/><b>Paciente: </b>" + response.prescription[i].NamePatient + "<br/><b>Próxima cita: </b>" + response.prescription[i].NextAppointment,
                        customer: response.prescription[i].NameCustomer,
                        start: this.setDate(response.prescription[i].NextAppointment),
                        end: this.setDate(response.prescription[i].NextAppointment),
                        color: 'green',
                        timed: false,
                    })
                }

                for (let i = 0; i < response.vaccineAndMedication.length; i++) {
                    let vaccOrMedicine1 = response.vaccineAndMedication[i].ItemType == 'VAC' ? "vacunación" : 'medicación'
                    let vaccOrMedicine2 = response.vaccineAndMedication[i].ItemType == 'VAC' ? "la vacuna" : 'el medicamento'
                    let text = "<b>Nota:</b> Se espera su visita para recibir " + vaccOrMedicine2 + " " + response.vaccineAndMedication[i].NameItem
                    events.push({
                        name: "Cita de " + vaccOrMedicine1,
                        details: "<b>Cliente: </b> " + response.vaccineAndMedication[i].NameCustomer + "<br/><b>Paciente: </b>" + response.vaccineAndMedication[i].NamePatient + "<br/>" + text,
                        customer: response.vaccineAndMedication[i].NameCustomer,
                        start: this.setDate(response.vaccineAndMedication[i].NextAppointment),
                        end: this.setDate(response.vaccineAndMedication[i].NextAppointment),
                        color: 'blue',
                        timed: false
                    })
                }

                for (let i = 0; i < response.grooming.length; i++) {
                    events.push({
                        name: "Cita de peluquería",
                        details: "<b>Cliente: </b> " + response.grooming[i].NameCustomer + "<br/><b>Paciente: </b>" + response.grooming[i].NamePatient + "<br/><b>Peluquero: </b>" + response.grooming[i].Groomer,
                        customer: response.grooming[i].NameCustomer,
                        start: this.setDate(response.grooming[i].NextAppointment),
                        end: this.setDate(response.grooming[i].NextAppointment),
                        color: 'purple',
                        timed: false
                    })

                    events2.push({
                        name: "Cita de peluquería",
                        patient: response.grooming[i].NamePatient,
                        customer: response.grooming[i].NameCustomer,
                        customerID: response.grooming[i].ID_Customer,
                        details: "<b>Cliente: </b> " + response.grooming[i].NameCustomer + "<br/><b>Paciente: </b>" + response.grooming[i].NamePatient + "<br/><b>Peluquero: </b>" + response.grooming[i].Groomer,
                        start: this.setDate(response.grooming[i].NextAppointment),
                        end: this.setDate(response.grooming[i].NextAppointment),
                        color: 'purple',
                        timed: false,
                        patientId: response.grooming[i].ID_Patient,
                        GroomingSize: response.grooming[i].GroomingSize,
                        GroomingGroomer: response.grooming[i].GroomingGroomer,
                        GroomingTypeOfService: response.grooming[i].GroomingTypeOfService,
                        GroomingVisit: response.grooming[i].GroomingVisit,
                        SpecialStatus: response.grooming[i].SpecialStatus
                    })
                }

                for (let i = 0; i < response.calendar.length; i++) {
                    let eventData = response.calendar[i]
                    let color = 'grey darken-1'

                    if (eventData.SpecialStatus === 'grooming') {
                        color = eventData.isDomicilio == 1 ? 'green' : 'purple'
                    } else if(eventData.SpecialStatus === 'cats') {
                         color = eventData.Domicilio === 1 ? 'green' : 'orange'
                    }

                    events.push({
                        id: eventData.ID,
                        name: eventData.AppointmentName,
                        customer: eventData.NameCustomer,
                        patient: eventData.NamePatient,
                        details: eventData.AppointmentDetails,
                        start: this.setDateWithHour(eventData.AppointmentStartDate, eventData.AppointmentStartHour),
                        end: this.setDateWithHour(eventData.AppointmentEndDate, eventData.AppointmentEndHour),
                        color,
                        timed: true,
                        specialStatus: eventData.SpecialStatus,
                        serviceType: eventData.GroomingTypeOfService
                    })

                    if (eventData.SpecialStatus == 'grooming') {
                        const isDomicilio = eventData.Domicilio !== undefined ? eventData.Domicilio : 0
                        events2.push({
                            id: eventData.ID,
                            name: eventData.AppointmentName,
                            patient: eventData.NamePatient,
                            customer: eventData.NameCustomer,
                            customerID: eventData.ID_Customer || null,
                            appointmentDetails: eventData.AppointmentDetails,
                            details: "<b>Cliente: </b> " + eventData.NameCustomer + "<br/>" +
                                "<b>Paciente: </b> " + eventData.NamePatient + "<br/>" +
                                "<b>Tipo de servicio: </b> " + eventData.GroomingTypeOfService + "<br/>" +
                                "<b>Tamaño: </b> " + eventData.GroomingSize + "<br/>" +
                                "<b>Peluquero: </b> " + eventData.GroomingGroomer + "<br/>" +
                                "<b>Visita: </b> " + eventData.GroomingVisit + "<br/>" +
                                "<b>Ubicación: </b> " + (eventData.Domicilio === 1 ? "Domicilio" : "Local") + "<br/>" +
                                "<b>Detalles de la cita: </b> " + eventData.AppointmentDetails,
                            start: this.setDateWithHour(eventData.AppointmentStartDate, eventData.AppointmentStartHour),
                            end: this.setDateWithHour(eventData.AppointmentEndDate, eventData.AppointmentEndHour),
                            color: isDomicilio == 1 ? 'green' : 'purple',
                            timed: true,
                            patientId: eventData.ID_Patient,
                            GroomingSize: eventData.GroomingSize,
                            GroomingGroomer: eventData.GroomingGroomer,
                            GroomingTypeOfService: eventData.GroomingTypeOfService,
                            GroomingVisit: eventData.GroomingVisit,
                            SpecialStatus: eventData.SpecialStatus,
                            Domicilio: eventData.Domicilio !== undefined ? eventData.Domicilio : 0
                        })
                    }
                }

                this.events = events
                this.events2 = events2

                // Procesar eventos para calendario de gatos
                this.eventsCats = [];
                if (response.cats && Array.isArray(response.cats)) {
                    for (let i = 0; i < response.cats.length; i++) {
                        this.eventsCats.push({
                            id: response.cats[i].ID,
                            name: response.cats[i].AppointmentName,
                            patient: response.cats[i].NamePatient,
                            customer: response.cats[i].NameCustomer,
                            customerID: response.cats[i].ID_Customer || null,
                            appointmentDetails: response.cats[i].AppointmentDetails,
                            details: `<b>Cliente: </b> ${response.cats[i].NameCustomer}<br/>` +
                                     `<b>Paciente: </b> ${response.cats[i].NamePatient}<br/>` +
                                     `<b>Tipo de servicio: </b> ${response.cats[i].GroomingTypeOfService || ''}<br/>` +
                                     `<b>Ubicación: </b> ${(response.cats[i].Domicilio === 1 ? 'Domicilio' : 'Local')}<br/>` +
                                     `<b>Detalles de la cita: </b> ${response.cats[i].AppointmentDetails || ''}`,
                            start: this.setDateWithHour(response.cats[i].AppointmentStartDate, response.cats[i].AppointmentStartHour),
                            end: this.setDateWithHour(response.cats[i].AppointmentEndDate, response.cats[i].AppointmentEndHour),
                            color: response.cats[i].Domicilio === 1 ? 'green' : 'orange',
                            timed: true,
                            patientId: response.cats[i].ID_Patient,
                            GroomingSize: response.cats[i].GroomingSize,
                            GroomingGroomer: response.cats[i].GroomingGroomer,
                            GroomingTypeOfService: response.cats[i].GroomingTypeOfService,
                            GroomingVisit: response.cats[i].GroomingVisit,
                            SpecialStatus: response.cats[i].SpecialStatus,
                            Domicilio: response.cats[i].Domicilio !== undefined ? response.cats[i].Domicilio : 0
                        });
                    }
                }
            }).catch((err) => {
                console.log(err)
                this.events = events
                this.events2 = events2
            })
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },

        setDate(date) {
            const dateStr = date;

            const splitDate = dateStr.split('/');
            const day = parseInt(splitDate[0], 10);
            const month = parseInt(splitDate[1], 10) - 1; // Resta 1 al mes porque en JavaScript los meses van de 0 a 11
            const year = parseInt(splitDate[2], 10);

            const dateFormat = new Date(year, month, day);

            return dateFormat
        },

        setDateWithHour(dateStr, hourStr) {
            const [day, month, year] = dateStr.split('/').map(Number);
            const [hour, minute] = hourStr.split(':').map(Number);

            //const date = new Date(year, month - 1, day, hour, minute);
            const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
            return utcDate
        },

        updateDateTime() {
            if (this.selectedDate && this.selectedTime) {
                const [hours, minutes] = this.selectedTime.split(':');
                this.selectedDate.setHours(Number(hours), Number(minutes), 0, 0);
            }
        },

        addAppointmentDate(){
            this.$API.veterinaryCalendar.postAddAppointment({ appointment: this.appointmentForm }).then(response => {
                this.showForm = false
                this.showAlert("success", "Exito", response.message, "add")
            })  
            .catch(err => {
                this.showAlert("danger", "Error", err.message)
            })
        },

        delSelectedOpen() {
            if (this.selectedEvent){
                const eventIdToDelete = this.selectedEvent.id;

                this.$API.veterinaryCalendar.postDelAppointment({ ID_Appointment: eventIdToDelete}).then(response => {
                    this.events = this.events.filter(event => event.id !== eventIdToDelete)
                    this.events2 = this.events2.filter(event => event.id !== eventIdToDelete)
                    this.selectedOpen = false
                    this.showAlert("success", "Exito", response.message)
                })
                .catch(err => {
                    this.selectedOpen = false
                    this.showAlert("danger", "Error", err.message)
                })
                
            }
        },

        openModalByButton() {
            const selectedTime1 = new Date(`January 1, 2024 07:00`);
            const selectedTime2 = new Date(`January 1, 2024 07:30`);
            let formattedTime1 = selectedTime1.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
            let formattedTime2 = selectedTime2.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
            const currentDate = new Date();
            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
            const year = currentDate.getFullYear();
            const formattedDateString = `${day}/${month}/${year}`;

            this.appointmentForm.AppointmentName = '';
            this.appointmentForm.AppointmentDetails = '';
            this.appointmentForm.AppointmentStartDate = formattedDateString;
            this.appointmentForm.AppointmentEndDate = formattedDateString;
            this.appointmentForm.AppointmentStartHour = formattedTime1;
            this.appointmentForm.AppointmentEndHour = formattedTime2;
            this.appointmentForm.ID_Patient = null
            this.appointmentForm.ID_Customer = null
            this.appointmentForm.SpecialStatus = null;
            this.appointmentForm.GroomingTypeOfService = null;
            this.appointmentForm.GroomingSize = null;
            this.appointmentForm.GroomingGroomer = null;
            this.appointmentForm.GroomingVisit = null;
            this.appointmentForm.id = null;
            
            this.showTablePatients = false
            this.selectedPatient = null
            this.showForm = true
        },
        openModalByTime({ time, date }) {
            const selectedTime = new Date(`January 1, 2024 ${time}`);
            if (selectedTime.getMinutes() >= 30) {
                selectedTime.setMinutes(30);
            } else {
                selectedTime.setMinutes(0);
            }
            let formattedTime = selectedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
            selectedTime.setMinutes(selectedTime.getMinutes() + 30);
            let formattedTime2 = selectedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
            const formattedDate = new Date(date);
            formattedDate.setDate(formattedDate.getDate() + 1); // Suma un día
            const day = String(formattedDate.getDate()).padStart(2, '0');
            const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
            const year = formattedDate.getFullYear();
            const formattedDateString = `${day}/${month}/${year}`;

            // Determinar el nombre y el SpecialStatus según el calendario
            if (this.typeCalendar == 3) {
                this.appointmentForm.AppointmentName = 'Cita';
                this.appointmentForm.SpecialStatus = 'cats';
            } else {
                this.appointmentForm.AppointmentName = 'Cita peluqueria';
                this.appointmentForm.SpecialStatus = 'grooming';
            }
            this.appointmentForm.AppointmentDetails = '';
            this.appointmentForm.AppointmentStartDate = formattedDateString;
            this.appointmentForm.AppointmentEndDate = formattedDateString;
            this.appointmentForm.AppointmentStartHour = formattedTime;
            this.appointmentForm.AppointmentEndHour = formattedTime2;
            this.appointmentForm.ID_Patient = null;
            this.appointmentForm.ID_Customer = null;
            this.appointmentForm.GroomingTypeOfService = null;
            this.appointmentForm.GroomingSize = null;
            this.appointmentForm.GroomingGroomer = null;
            this.appointmentForm.GroomingVisit = null;
            this.appointmentForm.id = null

            this.showTablePatients = true
            this.selectedPatient = null
            this.showForm = true 
        },
        filterHandlerPatients(response) {
            this.patientsWithCustomer = response
        },
        handleSelection(patient) {
            if (patient === null) {
                this.appointmentForm.ID_Patient = null
                this.appointmentForm.ID_Customer = null
                this.selectedPatient = null;
            } else if (this.selectedPatient === patient) {
                this.selectedPatient = null;
            } else {
                this.appointmentForm.ID_Patient = patient.ID_Patient
                this.appointmentForm.ID_Customer = patient.ID_Customer
                this.selectedPatient = patient;
                // Asignar otros valores según sea necesario
            }
            this.appointmentForm.id = null;
        },
        editEvent() {
            // Llena el formulario con los datos del evento seleccionado
            const event = this.selectedEvent;
            // Registrar el id del evento en el formulario esto para saber si es una cita nueva o una edición
            this.appointmentForm.id = event.id || null;

            // Si el evento tiene los campos necesarios, asígnalos al formulario
            this.appointmentForm.AppointmentName = event.name || '';
            this.appointmentForm.AppointmentDetails = event.appointmentDetails || '';
            this.appointmentForm.AppointmentStartDate = event.start
            ? this.formatDate(event.start)
            : '';
            this.appointmentForm.AppointmentEndDate = event.end
            ? this.formatDate(event.end)
            : '';
            this.appointmentForm.AppointmentStartHour = event.timeStart || '07:00';
            this.appointmentForm.AppointmentEndHour = event.timeEnd || '07:30';
            this.appointmentForm.ID_Patient = event.patientId || null;
            this.appointmentForm.ID_Customer = event.customerID || null;
            this.appointmentForm.SpecialStatus = event.SpecialStatus || null;
            this.appointmentForm.GroomingTypeOfService = event.GroomingTypeOfService || null;
            this.appointmentForm.GroomingSize = event.GroomingSize || null;
            this.appointmentForm.GroomingGroomer = event.GroomingGroomer || null;
            this.appointmentForm.GroomingVisit = event.GroomingVisit || null;
            
            this.appointmentForm.Domicilio = event.Domicilio !== undefined ? Number(event.Domicilio) : 0;

            // Selecciona el paciente si existe
            if (this.appointmentForm.ID_Patient && this.patientsWithCustomer.length > 0) {
            this.selectedPatient = this.patientsWithCustomer.find(
                p => p.ID_Patient === this.appointmentForm.ID_Patient
            ) || null;
            }

            if (!this.appointmentForm.ID_Patient) {
                this.editingGeneralAppointment = true
            }
            
            this.showTablePatients = !!this.selectedPatient;
            this.selectedOpen = false;
            this.showForm = true; 
        },
        formatDate(dateObj) {
            const date = new Date(dateObj);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        formatHour(dateObj) {
            const date = new Date(dateObj);
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            return `${hour}:${minute}`;
        },
        updateAppointment() {
            this.$API.veterinaryCalendar.postUpdateAppointment({ appointment: this.appointmentForm })
                .then(response => {
                    this.showForm = false;
                    this.showAlert("success", "Éxito", response.message, "add");
                })
                .catch(err => {
                    this.showAlert("danger", "Error", err.message);
                });
        },
        updateRangeCats() {
            this.eventsCats = [
                {
                    name: "Cita de gato",
                    details: "<b>Cliente:</b> Ejemplo Cliente<br/><b>Paciente:</b> Gato Ejemplo",
                    start: new Date(),
                    end: new Date(),
                    color: 'orange',
                    timed: false
                }
            ];
        },
        checkFileType(filename) {
            const validExtensions = ['xlsx', 'xls', 'pdf', 'doc', 'docx'];
            const fileExtension = filename.split('.').pop().toLowerCase();
            return validExtensions.includes(fileExtension);
        },
        async showLastPhoto() {
            const event = this.selectedEvent;
            if (!event.patientId) return;
            this.loading = true;
            this.imageUrl = null;
            this.imagesToShow.length = 0;
            const images = await this.$API.veterinaryImages.getImages(event.patientId);
            if (images.length > 0) {
                for (const element of images) {
                    await this.filesByImageID(element.ID_Images)
                }
            }
            this.loading = false;
            this.ZoomDialog = true;
        },
        async filesByImageID(id) {
            this.loading = true;

            await this.$API.veterinaryImages.filesByImageID(id).then(
                (res) => {
                    this.imagesToShow = [...this.imagesToShow, ...res.files];
                    this.imagesToShow = this.imagesToShow.filter(ele => this.checkFileType(ele.Picture) === false && ele.TypeOfImage === 'Peluquería');
                    if (this.imagesToShow.length > 0) {
                        this.imageUrl = this.imagesToShow[this.imagesToShow.length - 1].Path;
                    }
                    this.loading = false;
                    },
                    (err) => {
                    // this.$toasted.info(err.message);
                    console.log('error', err);
                    this.loading = false;
                }
            );
        },
    },
}
</script>
<style>
.v-btn--fab.v-size--small {
    top: 0px !important;
}

@media (max-width: 959px) {
  .spacerow {
    margin-top: 40px!important; /* Ajusta según necesidad */
    margin-bottom: 40px!important; /* Ajusta según necesidad */
  }
}

.v-calendar-daily__interval-text, .v-calendar-daily_head-weekday, .v-calendar-daily_head-day-label {
    font-weight: bold; /* Opcional: para hacer el texto más grueso */
}

.notImgs{
    font-size: large;
    height: 50dvh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>